import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { IVideoThumbnail } from "../../../main/components/videos/models/IVideoThumbnail";
import "./veriVideoThumbnails.component.scss";

@Component({
    selector: "veri-video-thumbnails",
    template: require("./veriVideoThumbnails.component.html")
})
export class VeriVideoThumbnailsComponent implements OnInit, OnChanges {

    @Input() thumbnails: IVideoThumbnail[];
    @Input() selectedThumbnail: IVideoThumbnail;
    @Input() tinyMode: boolean = false;

    // ---

    primaryThumbnails: IVideoThumbnail[];
    secondaryThumbnails: IVideoThumbnail[];

    selectedSecondaryThumbnail: IVideoThumbnail;

    highlightPrimaryThumbnail = true;

    constructor() { }

    trackThumbnail(index: number, row: IVideoThumbnail): number { return row.Id; }

    ngOnInit(): void {
        //if (!this.tinyMode) {
        //    this.selectThumbnail(this.thumbnails[0]);
        //}
    }

    ngOnChanges(changes: SimpleChanges) {
        this.primaryThumbnails = this.thumbnails;

        if (this.thumbnails.length >= 16) {
            this.primaryThumbnails = [];
            this.secondaryThumbnails = [];

            this.thumbnails.forEach((t, i) => {
                if (i % 2 != 0) {
                    this.primaryThumbnails.push(t);
                }
                else {
                    this.secondaryThumbnails.push(t);
                }
            });
        }

        this.selectThumbnail(this.primaryThumbnails[0]);
    }

    selectThumbnail(selectedThumbnail: IVideoThumbnail): void {
        if (!selectedThumbnail) {
            return;
        }

        this.selectedThumbnail = this.thumbnails.find(thumbnail => thumbnail === selectedThumbnail);

        if (this.secondaryThumbnails?.length) {
            var index = this.primaryThumbnails.findIndex(t => t == this.selectedThumbnail);
            this.selectedSecondaryThumbnail = this.secondaryThumbnails[index];
        }

        if (!this.highlightPrimaryThumbnail) {
            this.swapSelectedThumbnails();
        }
    }

    deselectThumbnail(): void {
        if (!this.tinyMode) {
            return;
        }

        this.selectedThumbnail = null;
    }

    swapThumbnails() {
        this.highlightPrimaryThumbnail = !this.highlightPrimaryThumbnail;
        this.swapSelectedThumbnails();
    }

    //

    private swapSelectedThumbnails() {

        const temp = this.selectedThumbnail;
        this.selectedThumbnail = this.selectedSecondaryThumbnail;
        this.selectedSecondaryThumbnail = temp;
    }
}
